<mat-form-field appearance="outline">
  <ngx-spinner [zIndex]="-1" name="spListadoPaises" bdColor="rgba(255,255,255,0.8)" size="small"
    color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>

  <mat-label>Selecciona un país</mat-label>
  <input type="text" matInput formControlName="Pais" [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedCountry($event.option.value)">
    <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name.common">
      <img [src]="country.flags.svg" alt="Bandera de {{ country.name }}" width="24" style="margin-right: 8px;">

      <span class="country-name">{{ country.name?.common }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="form.controls['Pais'].hasError('required')">El nombre es
    <strong>requerido</strong>
  </mat-error>
</mat-form-field>
